import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"search\"><path d=\"M9.26,0a9.26,9.26,0,0,1,7.3,15l5.11,5.11a1.12,1.12,0,0,1-1.59,1.59L15,16.56A9.26,9.26,0,1,1,9.26,0Zm0,2.18A7.09,7.09,0,1,0,14,14.52a1.21,1.21,0,0,1,.2-.3,1.61,1.61,0,0,1,.3-.21A7.08,7.08,0,0,0,9.26,2.18Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol